import { Entitlements } from '../../../entitlements';
import { Feature } from '../../feature-flags';

/**
 * If a property of the VisibilityFeatureConditions is defined,
 * then at least one of the conditions in that property must be
 * active/true for the feature to be considered visible
 */
export interface BoVisibilityFeatureConditions {
    featureFlags?: Feature | Feature[];
    entitlements?: Entitlements | Entitlements[];
}

export enum BoVisibilityFeature {}
